import { UpdateServiceConfig } from "@/types/update.types";

export const DEFAULT_MESSAGES = {
  title: "Вышла новая версия приложения!",
  description: "Обновите приложение для продолжения работы.",
  additionalDescription: "Приложение будет перезагружено через {timeLeft}.",
} as const;

export const defaultConfig: UpdateServiceConfig = {
  versionFileUrl: "./version",
  timeForUpdateOrPageReload: "5m",
  checkInterval: "1m",
  messages: DEFAULT_MESSAGES,
  currentVersion: null,
};
